import { ProductForm, SEL_FORM_CONTAINER } from "./product-form";
import {  CLASS_THUMB_INITIALISED } from "../../tools/constants/classes";
import { Swatches } from "./swatches";

const SEL_PRODUCT_THUMBNAIL = '[data-product-thumbnail]';

const ACTIVE_THUMBNAILS:ProductThumbnail[] = [];

class ProductThumbnail {
  private container:HTMLElement;
  private formElement:HTMLFormElement|null = null;
  private form:ProductForm|null = null;
  swatches: Swatches | null = null;

  constructor(container: HTMLElement) {
    this.container = container;
    this.queryChildren(container);
    this.attachEvents();
  }

  queryChildren(container: HTMLElement): void {
    this.formElement = container.querySelector(SEL_FORM_CONTAINER);
  }

  attachEvents() {
    if(this.formElement) this.form = new ProductForm(this.formElement);
    if(ACTIVE_THUMBNAILS.indexOf(this) === -1) ACTIVE_THUMBNAILS.push(this);
    this.swatches = new Swatches(this.container, false);
  
  }

  detatchEvents() {
    if(this.form) this.form.detatchEvents();
    const i = ACTIVE_THUMBNAILS.indexOf(this);
    if(i !== -1) ACTIVE_THUMBNAILS.splice(i, 1);
  }
}

export const initialiseProductThumbnails = () => {

  [...ACTIVE_THUMBNAILS].forEach(thumbnail => {
    // if(thumbnail) return;
    thumbnail.detatchEvents();
  });

  document.querySelectorAll<HTMLElement>(SEL_PRODUCT_THUMBNAIL).forEach(thumb => {
    if(thumb.classList.contains(CLASS_THUMB_INITIALISED)) return;
    thumb.classList.add(CLASS_THUMB_INITIALISED);

    new ProductThumbnail(thumb);
  });
}

initialiseProductThumbnails();